import { getClient, QuoteDto } from "@lg-cfa/services";
import { AxiosInstance } from "axios";

import {
    FireLeadRequestBodyV2,
    FireWtcRequestBodyV2,
    GetTariffOptionsParameterObject,
    GetTariffParameterObject,
    TariffV2Basic,
    TariffV2Option,
} from "@types";

/**
 * Service class for managing fire Lead related operations.
 */

class FireService {
    /**
     * HTTP client instance for making requests.
     */
    public client: AxiosInstance;

    /**
     * Base path for fire-related API endpoints.
     */
    private basePath = "fire";

    constructor() {
        this.client = getClient();
    }

    /**
     * Constructs the full API endpoint path.
     * @param path - The specific endpoint path to append to the base path.
     * @returns The full API endpoint path.
     */
    private getFullPath(path = ""): string {
        return `${this.basePath}${path}`;
    }

    public getTariffV2(getTariffParameterObject: GetTariffParameterObject) {
        return this.client
            .post<TariffV2Basic>(
                this.getFullPath("/quotes/tariffsv2/basetariffs"),
                getTariffParameterObject,
            )
            .then((result) => result.data);
    }

    public getTariffV2Options(
        optionTariffObject: GetTariffOptionsParameterObject,
    ) {
        return this.client
            .post<
                TariffV2Option[]
            >(this.getFullPath("/quotes/tariffsv2/tariffOptions"), optionTariffObject)
            .then((result) => result.data);
    }

    public getBusinessRules() {
        return this.client
            .get<{
                [key: string]: number;
            }>(this.getFullPath("/businessrules"))
            .then((result) => result.data);
    }

    public captureWTCFireLeadV2(fireWtcRequestBodyV2: FireWtcRequestBodyV2) {
        return this.client
            .post<QuoteDto>(
                this.getFullPath("/quotes/wtcV2"),
                fireWtcRequestBodyV2,
            )
            .then((result) => result.data);
    }

    public captureFireLeadV2(fireLeadRequestBodyV2: FireLeadRequestBodyV2) {
        return this.client.post<QuoteDto>(
            this.getFullPath("/quotesV2"),
            fireLeadRequestBodyV2,
        );
    }
}

export const fireService = new FireService();
